class BionyTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
    });
  }

  activate(tab) {
    this.tabs.forEach((t) => {
      const selected = t === tab;
      t.setAttribute('aria-selected', selected);
      t.tabIndex = selected ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });
    tab.focus();
  }

  onKeydown(event, tab) {
    const index = this.tabs.indexOf(tab);
    let target = null;
    if (event.key === 'ArrowRight') target = this.tabs[(index + 1) % this.tabs.length];
    if (event.key === 'ArrowLeft') target = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
    if (target) {
      event.preventDefault();
      this.activate(target);
    }
  }
}

if (!customElements.get('biony-tabs')) {
  customElements.define('biony-tabs', BionyTabs);
}
